import { render, staticRenderFns } from "./MaterialsStockByCityStatistics.vue?vue&type=template&id=05664778"
import script from "./MaterialsStockByCityStatistics.vue?vue&type=script&lang=js"
export * from "./MaterialsStockByCityStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports